export default __webpack_public_path__ + "static/8854370-4c27a38eab0e56d67d1d1c96e630b776.png";